// コレクションのタブ切り替え
document.addEventListener(
  "DOMContentLoaded",
  function () {
    const tabs = document.getElementsByClassName("section-collection-tab");
    for (let i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener("click", tabSwitch, false);
    }

    function tabSwitch() {
      const elem = this.parentNode;
      elem.getElementsByClassName("is-active")[0].classList.remove("is-active");
      this.classList.add("is-active");

      const target = this.dataset.panel;
      const parentElem = this.parentNode.parentNode;
      const panelContent = parentElem.querySelector(
        '[data-collection="' + target + '"]'
      );

      parentElem
        .getElementsByClassName("is-show")[0]
        .classList.remove("is-show");
      panelContent.classList.add("is-show");
    }
  },
  false
);

// ハンバーガーメニュー、検索ドロワー
const humbergur = document.querySelector(".js-hamburger");
const menuElem = document.querySelector(".header__inline-menu");
const bgElem = document.querySelector(".js-bg");
const htmlElem = document.querySelector("html");
const searchBtn = document.querySelector(".js-search-btn");
const searchElem = document.querySelector(".js-search-drawer");
const tabs = document.getElementsByClassName("header__mega-parent__menu");
const menuParent = document.querySelector(".header__mega-menu");
const menuchild = document.querySelector(".header__mega-child");
const menuSpacer = 50;

const accountSidebarButton = document.querySelector(".js-account-sidebar-btn");
const accountSidebar = document.querySelector(".account-sidebar-menu");

for (let i = 0; i < tabs.length; i++) {
  tabs[i].addEventListener("click", tabSwitch, false);
}

function tabSwitch() {
  const elem = this.parentNode;
  if (elem.getElementsByClassName("is-active").length > 0) {
    elem.getElementsByClassName("is-active")[0].classList.remove("is-active");
  }

  this.classList.add("is-active");

  const target = this.dataset.cat;
  const parentElem = this.parentNode;
  const panelContent = this.querySelector('[data-mega="' + target + '"]');
  if (parentElem.getElementsByClassName("is-show").length > 0) {
    parentElem.getElementsByClassName("is-show")[0].classList.remove("is-show");
  }
  const headerHeight = document.querySelector(".header__inner").clientHeight;
  const windowHeight = window.innerHeight + menuSpacer;
  const header = windowHeight - headerHeight;
  // menuchild.style.height = header + "px";
  panelContent.classList.add("is-show");
}

humbergur.addEventListener("click", function () {
  const result = humbergur.classList.contains("is-open");
  const parentResult =
    menuElem?.getElementsByClassName("is-active")?.length > 0;
  const childResult = menuElem?.getElementsByClassName("is-show")?.length > 0;

  // Reset account sidebar icon when hamburger is clicked
  const ellipsisIcon = accountSidebarButton.querySelector(
    ".account-sidebar-icon-ellipsis"
  );
  const closeIcon = accountSidebarButton.querySelector(
    ".account-sidebar-icon-close"
  );

  accountSidebar.classList.remove("is-open");

  // Reset to ellipsis icon since account sidebar is being closed
  if (ellipsisIcon && closeIcon) {
    ellipsisIcon.style.display = "";
    closeIcon.style.display = "none";
  }

  if (result) {
    menuElem.classList.remove("is-open");
    if (parentResult) {
      menuElem
        .getElementsByClassName("is-active")[0]
        .classList.remove("is-active");
      searchBtn.disabled = false;
      if (childResult) {
        menuElem
          .getElementsByClassName("is-show")[0]
          .classList.remove("is-show");
      }
    }
    humbergur.classList.remove("is-open");
    bgElem.classList.remove("is-open");
    htmlElem.classList.remove("is-open");
    searchBtn.disabled = false;
  } else {
    const headerHeight = document.querySelector(".header__inner").clientHeight;
    const windowHeight = window.innerHeight + menuSpacer;
    const header = windowHeight - headerHeight;
    menuParent.style.height = header + "px";
    menuElem.classList.add("is-open");
    bgElem.classList.add("is-open");
    humbergur.classList.add("is-open");
    htmlElem.classList.add("is-open");
    searchBtn.disabled = true;
  }
});

accountSidebarButton.addEventListener("click", function () {
  const result = accountSidebar.classList.contains("is-open");
  const parentResult =
    accountSidebar?.getElementsByClassName("is-active")?.length > 0;
  const childResult =
    accountSidebar?.getElementsByClassName("is-show")?.length > 0;

  // Get icon elements
  const ellipsisIcon = accountSidebarButton.querySelector(
    ".account-sidebar-icon-ellipsis"
  );
  const closeIcon = accountSidebarButton.querySelector(
    ".account-sidebar-icon-close"
  );

  humbergur.classList.remove("is-open");
  menuElem.classList.remove("is-open");
  menuElem.classList.remove("is-show");
  menuElem.classList.remove("is-active");
  if (result) {
    accountSidebar.classList.remove("is-open");
    if (parentResult) {
      accountSidebar
        .getElementsByClassName("is-active")[0]
        .classList.remove("is-active");
      if (childResult) {
        accountSidebar
          .getElementsByClassName("is-show")[0]
          .classList.remove("is-show");
      }
    }
    bgElem.classList.remove("is-open");
    htmlElem.classList.remove("is-open");

    // Show ellipsis, hide close icon
    ellipsisIcon.style.display = "";
    closeIcon.style.display = "none";
  } else {
    const headerHeight = document.querySelector(".header__inner").clientHeight;
    const windowHeight = window.innerHeight - 40;
    const header = windowHeight - headerHeight;
    accountSidebar.style.height = header + "px";
    accountSidebar.classList.add("is-open");
    bgElem.classList.add("is-open");
    htmlElem.classList.add("is-open");

    // Hide ellipsis, show close icon
    ellipsisIcon.style.display = "none";
    closeIcon.style.display = "";
  }
});
// 戻るボタン
const reverseBtns = document.getElementsByClassName("js-reverse");

function menuSwitch(e) {
  e.stopPropagation();
  menuElem?.getElementsByClassName("is-show")[0]?.classList?.remove("is-show");
}

for (let i = 0; i < reverseBtns.length; i++) {
  reverseBtns[i].addEventListener("click", menuSwitch, false);
}

// 検索ドロワー

searchBtn.addEventListener("click", function () {
  const result = searchElem.classList.contains("is-show");

  if (result) {
    searchElem.classList.remove("is-show");
    bgElem.classList.remove("is-open");
    htmlElem.classList.remove("is-open");
    humbergur.disabled = false;
  } else {
    searchElem.classList.add("is-show");
    bgElem.classList.add("is-open");
    htmlElem.classList.add("is-open");
    humbergur.disabled = true;
  }
});

// bgクリック
bgElem.addEventListener("click", function () {
  const parentResult =
    menuElem?.getElementsByClassName("is-active")?.length > 0;
  const childResult = menuElem?.getElementsByClassName("is-show")?.length > 0;

  // Reset account sidebar icon when background is clicked
  const ellipsisIcon = accountSidebarButton.querySelector(
    ".account-sidebar-icon-ellipsis"
  );
  const closeIcon = accountSidebarButton.querySelector(
    ".account-sidebar-icon-close"
  );

  menuElem.classList.remove("is-open");
  if (parentResult) {
    menuElem
      .getElementsByClassName("is-active")[0]
      .classList.remove("is-active");
    if (childResult) {
      menuElem
        ?.getElementsByClassName("is-show")[0]
        ?.classList?.remove("is-show");
    }
  }
  bgElem.classList.remove("is-open");
  humbergur.classList.remove("is-open");
  htmlElem.classList.remove("is-open");
  searchElem.classList.remove("is-show");
  humbergur.disabled = false;
  searchBtn.disabled = false;
  accountSidebar.classList.remove("is-open");

  // Reset to ellipsis icon since account sidebar is being closed
  if (ellipsisIcon && closeIcon) {
    ellipsisIcon.style.display = "";
    closeIcon.style.display = "none";
  }
});

//

window.addEventListener("resize", function () {
  if (window.innerWidth >= 1024) {
    menuchild.style.height = "auto";
    menuParent.style.height = "auto";
  }
});

// スクロールTOP
document.addEventListener("DOMContentLoaded", function () {
  var scrollTimeout;
  const scrollBtn = document.querySelector(".js-scroll-top");
  scrollBtn.addEventListener("click", scrollTop);
  function scrollTop() {
    window.scroll({ top: 0, behavior: "smooth" });
    // fixedElm.style.marginTop = announceBarHeight + "px"
    // fixedElm.classList.remove('fixed-show')
  }
  window.addEventListener("scroll", scrollEvent);
  function scrollEvent() {
    scrollBtn.classList.remove("is-active");
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      if (window.pageYOffset > 400) {
        scrollBtn.classList.add("is-active");
      } else if (window.pageYOffset < 400) {
        scrollBtn.classList.remove("is-active");
      }
    }, 3000);
  }

  function hideScrollButton() {
    scrollBtn.classList.remove("is-active");
  }
  // スクロールボタンの非表示を設定
  window.addEventListener("scroll", hideScrollButton);
});

// アコーディオン
const slideUp = (el, duration = 300) => {
  el.style.height = el.offsetHeight + "px";
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  setTimeout(() => {
    el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
    el.classList.remove("is-open");
  }, duration);
};

// 要素をスライドしながら表示する関数(jQueryのslideDownと同じ)
const slideDown = (el, duration = 300) => {
  el.classList.add("is-open");
  el.style.removeProperty("display");
  let display = window.getComputedStyle(el).display;
  if (display === "none") {
    display = "block";
  }
  el.style.display = display;
  let height = el.offsetHeight;
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.height = height + "px";
  el.style.removeProperty("padding-top");
  el.style.removeProperty("padding-bottom");
  el.style.removeProperty("margin-top");
  el.style.removeProperty("margin-bottom");
  setTimeout(() => {
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};

// 要素をスライドしながら交互に表示/非表示にする関数(jQueryのslideToggleと同じ)
const slideToggle = (el, duration = 300) => {
  if (window.getComputedStyle(el).display === "none") {
    return slideDown(el, duration);
  } else {
    return slideUp(el, duration);
  }
};

// アコーディオンを全て取得
const accordions = document.querySelectorAll(".js-accordion");
// 取得したアコーディオンをArrayに変換(IE対策)
const accordionsArr = Array.prototype.slice.call(accordions);

accordionsArr.forEach((accordion) => {
  // Triggerを全て取得
  const accordionTriggers = accordion.querySelectorAll(".accordion__title");
  // TriggerをArrayに変換(IE対策)
  const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);

  accordionTriggersArr.forEach((trigger) => {
    // Triggerにクリックイベントを付与
    trigger.addEventListener("click", () => {
      // '.is-active'クラスを付与or削除
      trigger.classList.toggle("is-active");
      // 開閉させる要素を取得
      const content = trigger.nextElementSibling;
      // 要素を展開or閉じる
      slideToggle(content);
    });
  });
});

// 追従ヘッダー
const mediaQueryList = window.matchMedia("(min-width: 599px)");
const fixedElm = document.getElementById("sticky__header");
const announceBarElm = document.querySelector(".announcement-bar");
let announceBarHeight = announceBarElm.clientHeight;
let fixedElmHeight = fixedElm.clientHeight;

const mainElem = document.getElementById("MainContent");
let announceBarRect = announceBarElm?.getBoundingClientRect();
let elembotom = announceBarRect.bottom + window.pageYOffset;
var stickyHeaderMargin = announceBarHeight;
if (window.innerWidth > 1024) {
  stickyHeaderMargin = 40;
}

document.addEventListener("DOMContentLoaded", function () {
  // mainElem.style.marginTop = fixedElmHeight + "px";
  // fixedElm.style.marginTop = stickyHeaderMargin + "px"
});

var cachedWindowWidth = window.innerWidth;

window.addEventListener("resize", function () {
  // Because resize is called in scroll in Safari (mobile) which causes slight layout shift
  if (window.innerWidth == cachedWindowWidth) return;

  cachedWindowWidth = window.innerWidth;
  // mainElem.style.marginTop = stickyHeaderMargin + "px";
  // fixedElm.style.marginTop = stickyHeaderMargin + "px";
});
const listener = (event) => {
  // リサイズ時に行う処理
  if (event.matches) {
    // その他
    let scrollPoint = 0; // 現在のスクロール位置をセットする変数
    let lastPoint = 0; // 1つ前のスクロール位置をセットする変数

    window.addEventListener("scroll", function () {
      scrollPoint = window.scrollY;

      if (scrollPoint === 0) {
        fixedElm.style.position = "relative";
        fixedElm.style.marginTop = 0;
        fixedElm.classList.remove("fixed-show");
        return;
      }

      if (scrollPoint > lastPoint) {
        // 下スクロールの場合

        if (scrollPoint > elembotom) {
          fixedElm.style.position = "fixed";
          fixedElm.classList.add("fixed-show");
          // fixedElm.style.marginTop = 0;
        } else {
          fixedElm.style.position = "relative";
          fixedElm.style.marginTop = "0px";
          // fixedElm.classList.remove('fixed-show')
        }
      } else {
        // 上スクロールの場合
        if (scrollPoint > elembotom) {
          fixedElm.style.top = 0;
          fixedElm.style.position = "fixed";
          fixedElm.classList.add("fixed-show");
          // fixedElm.style.marginTop = 0;
        } else {
          fixedElm.style.top = 0;
          // fixedElm.style.marginTop = stickyHeaderMargin + "px"
          fixedElm.classList.remove("fixed-show");
        }
      }
      lastPoint = scrollPoint;
    });
  } else {
    // 599px未満

    let scrollPoint = 0; // 現在のスクロール位置をセットする変数
    let lastPoint = 0; // 1つ前のスクロール位置をセットする変数

    window.addEventListener("scroll", function () {
      scrollPoint = window.scrollY;
      const announceBarHeight =
        document.querySelector(".announcement-bar")?.clientHeight;

      if (!isNaN(announceBarHeight) && scrollPoint > announceBarHeight) {
        fixedElm.style.top = 0;
        fixedElm.style.position = "fixed";
        fixedElm.classList.add("fixed-show");
        // fixedElm.style.marginTop = 0;
        // fixedElm.style.top = "-100%";
      } else {
        fixedElm.style.position = "relative";
        // fixedElm.style.marginTop = stickyHeaderMargin + "px"
        fixedElm.classList.remove("fixed-show");
      }
    });
  }
};

// リスナー登録
// mediaQueryList.addListener(listener); // @deprecated

// addEventListener is not supported in Safari < v14
if (mediaQueryList.addEventListener) {
  mediaQueryList.addEventListener("change", listener);
} else {
  mediaQueryList.addListener(listener);
}

// 初期化処理
listener(mediaQueryList);

// スクロールTOP
// document.addEventListener('DOMContentLoaded', function(){
//   const scrollBtn = document.querySelector('.js-scroll-top');
//   scrollBtn.addEventListener( 'click' , scrollTop );
//   function scrollTop(){
//     window.scroll({top: 0, behavior: 'smooth'});
//     // fixedElm.style.position = "relative";
//     // fixedElm.style.top = 0;
//     // fixedElm.classList.remove('fixed-show')
//     fixedElm.style.marginTop = announceBarHeight + "px"
//     fixedElm.classList.remove('fixed-show')
//   };
//   window.addEventListener( 'scroll' , scrollEvent );
//   function scrollEvent(){
//     if(window.pageYOffset > 400){
//       scrollBtn.classList.add("is-active")
//     }else if(window.pageYOffset < 400){
//       scrollBtn.classList.remove("is-active")
//     }
//   };
// });

// パララックス
document.addEventListener("DOMContentLoaded", function () {
  const image = document.getElementsByClassName("js-parallax");
  new simpleParallax(image);
});

// スムーズスクロール
window.addEventListener("DOMContentLoaded", () => {
  // Select all anchor links that start with "#"
  const anchorLinks = Array.from(document.querySelectorAll('a[href^="#"]'));

  // Filter out links that have href="#recover" or href="#login"
  const anchorLinksArr = anchorLinks.filter((link) => {
    const href = link.getAttribute("href");
    return href !== "#recover" && href !== "#login";
  });

  let spacer = 0;
  anchorLinksArr.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      if (window.innerWidth > 599) {
        spacer = 40;
      } else {
        let headerHeight =
          document.querySelector(".header__inner").clientHeight;
        spacer = headerHeight + 24;
      }
      const targetId = link.hash;

      if (!targetId) return;

      const targetElement = targetId ? document.querySelector(targetId) : null;
      const targetOffsetTop =
        window.pageYOffset +
        targetElement?.getBoundingClientRect().top -
        spacer;
      window.scrollTo({
        top: targetOffsetTop,
        behavior: "smooth",
      });
    });
  });
});

// マウスドラッグスクロール
function mousedragscrollable(element) {
  let target;
  const elms = document.querySelectorAll(element);
  for (let i = 0; i < elms.length; i++) {
    elms[i].addEventListener("mousedown", function (evt) {
      evt.preventDefault();
      target = elms[i];
      target.dataset.down = "true";
      target.dataset.move = "false";
      target.dataset.x = evt.clientX;
      target.dataset.y = evt.clientY;
      target.dataset.scrollleft = target.scrollLeft;
      target.dataset.scrolltop = target.scrollTop;
      evt.stopPropagation();
    });
    elms[i].addEventListener("click", function (evt) {
      if (elms[i].detaset != null && elms[i].detaset.move == "true")
        evt.stopPropagation();
    });
  }
  document.addEventListener("mousemove", function (evt) {
    if (target != null && target.dataset.down == "true") {
      evt.preventDefault();
      let move_x = parseInt(target.dataset.x) - evt.clientX;
      let move_y = parseInt(target.dataset.y) - evt.clientY;
      if (move_x !== 0 || move_y !== 0) {
        target.dataset.move = "true";
      } else {
        return;
      }
      target.scrollLeft = parseInt(target.dataset.scrollleft) + move_x;
      target.scrollTop = parseInt(target.dataset.scrolltop) + move_y;
      evt.stopPropagation();
    }
  });
  document.addEventListener("mouseup", function (evt) {
    if (target != null && target.dataset.down == "true") {
      target.dataset.down = "false";
      evt.stopPropagation();
    }
  });
}

window.addEventListener("DOMContentLoaded", function () {
  mousedragscrollable(".section-collection-tabs");
});

// アカウントドロップダウン機能
document.addEventListener("DOMContentLoaded", function () {
  const accountButton = document.querySelector(".js-account-dropdown-btn");
  const accountDropdown = document.getElementById("account-dropdown");
  if (accountButton && accountDropdown) {
    // ドロップダウンをボタンに追加
    accountButton.parentNode.appendChild(accountDropdown);

    // ボタンクリックでドロップダウンを切り替え
    accountButton.addEventListener("click", function (e) {
      console.log("here");
      e.preventDefault();
      e.stopPropagation();
      accountDropdown.classList.toggle("is-open");
    });

    // 外側クリックでドロップダウンを閉じる
    document.addEventListener("click", function (e) {
      if (
        !accountButton.contains(e.target) &&
        !accountDropdown.contains(e.target)
      ) {
        accountDropdown.classList.remove("is-open");
      }
    });

    // ESCキーでドロップダウンを閉じる
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && accountDropdown.classList.contains("is-open")) {
        accountDropdown.classList.remove("is-open");
        accountButton.focus();
      }
    });

    // ドロップダウン内のリンクフォーカス管理
    const dropdownLinks = accountDropdown.querySelectorAll("a");
    if (dropdownLinks.length > 0) {
      accountButton.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          accountDropdown.classList.toggle("is-open");
          if (accountDropdown.classList.contains("is-open")) {
            dropdownLinks[0].focus();
          }
        }
      });

      dropdownLinks.forEach((link, index) => {
        link.addEventListener("keydown", function (e) {
          if (e.key === "ArrowDown") {
            e.preventDefault();
            const nextIndex = (index + 1) % dropdownLinks.length;
            dropdownLinks[nextIndex].focus();
          } else if (e.key === "ArrowUp") {
            e.preventDefault();
            const prevIndex =
              (index - 1 + dropdownLinks.length) % dropdownLinks.length;
            dropdownLinks[prevIndex].focus();
          }
        });
      });
    }
  }
});
